const getColumnElementType = (element) => {
  if (!element) return null;

  if (element.matches && element.matches('ws-column')) {
    return 'column';
  }

  if (element.matches && element.matches('ws-columns')) {
    return 'columns';
  }

  return null;
};

export default getColumnElementType;
